"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleSwitchContainer = exports.SwitchRequired = exports.SwitchLabel = exports.SwitchError = exports.SwitchDot = exports.SwitchBackground = exports.Labeltext = exports.LabelContainer = exports.Checkbox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3;

var ToggleSwitchContainer = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitchstyles__ToggleSwitchContainer",
  componentId: "sc-1vf3qtx-0"
})([""]);

exports.ToggleSwitchContainer = ToggleSwitchContainer;

var Checkbox = _styledComponents["default"].input.withConfig({
  displayName: "ToggleSwitchstyles__Checkbox",
  componentId: "sc-1vf3qtx-1"
})(["display:none;"]);

exports.Checkbox = Checkbox;

var LabelContainer = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitchstyles__LabelContainer",
  componentId: "sc-1vf3qtx-2"
})(["display:flex;align-items:center;"]);

exports.LabelContainer = LabelContainer;

var SwitchBackground = _styledComponents["default"].label.withConfig({
  displayName: "ToggleSwitchstyles__SwitchBackground",
  componentId: "sc-1vf3qtx-3"
})(["background-color:", ";box-shadow:inset 0px 1px 2px rgba(0,0,0,0.24);border-radius:12px;width:48px;height:24px;display:flex;align-items:center;position:relative;display:inline-block;"], function (props) {
  return props.background ? props.theme.toggleSwitch.checked : props.theme.toggleSwitch.unchecked;
});

exports.SwitchBackground = SwitchBackground;

var SwitchDot = _styledComponents["default"].span.withConfig({
  displayName: "ToggleSwitchstyles__SwitchDot",
  componentId: "sc-1vf3qtx-4"
})(["display:inline-block;background:#ffffff;margin:0;box-shadow:0px 1px 3px rgba(0,0,0,0.35);width:20px;height:20px;border-radius:50%;position:absolute;left:", ";right:", ";top:2px;transition:all 0.3s ease-in 0s;"], function (props) {
  return props.checkedStatus ? 'auto' : '2px';
}, function (props) {
  return props.checkedStatus ? '2px' : 'auto';
});

exports.SwitchDot = SwitchDot;

var SwitchLabel = _styledComponents["default"].label.withConfig({
  displayName: "ToggleSwitchstyles__SwitchLabel",
  componentId: "sc-1vf3qtx-5"
})(["", " font-weight:400;color:#000;font-size:16px;margin-left:8px;"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["relative center tc"]))));

exports.SwitchLabel = SwitchLabel;

var SwitchError = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitchstyles__SwitchError",
  componentId: "sc-1vf3qtx-6"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["sans-serif w-100 red f7 pt1"]))));

exports.SwitchError = SwitchError;

var SwitchRequired = _styledComponents["default"].span.withConfig({
  displayName: "ToggleSwitchstyles__SwitchRequired",
  componentId: "sc-1vf3qtx-7"
})(["", " text-indent:0.15rem;"], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["red"]))));

exports.SwitchRequired = SwitchRequired;

var Labeltext = _styledComponents["default"].span.withConfig({
  displayName: "ToggleSwitchstyles__Labeltext",
  componentId: "sc-1vf3qtx-8"
})(["text-indent:0.15rem;"]);

exports.Labeltext = Labeltext;